import {apiClient} from 'app/components/shared';
import {EdgeBillingContract} from 'app/components/entities/billing/edge';

export class EdgeBillingApi {
  static async getEdgePlan(teamId: string): Promise<EdgeBillingContract.Plan> {
    return apiClient.get(`/front/api/v1t/team/${teamId}/teams/${teamId}/billing/plan`);
  }

  static async subscribe(teamId: string, seats: number): Promise<void> {
    return apiClient.post(`/front/api/v1t/team/${teamId}/billing/v2/edge/plan`, {
      seats: seats,
    });
  }

  static async unsubscribe(teamId: string): Promise<void> {
    return apiClient.delete(`/front/api/v1t/team/${teamId}/billing/v2/edge/plan`);
  }

  static async getHistory(teamId: string): Promise<EdgeBillingContract.History> {
    return apiClient.get(`/front/api/v1t/team/${teamId}/billing/v2/edge/invoice/history`);
  }
}
